<a
    [routerLink]="row().link"
    (click)="activate.emit()"
    [ngClass]="{ 'bg-base-200': selected() }"
    class="flex items-center gap-3 px-4 py-2 no-underline text-base-content cursor-pointer"
    data-testid="magicSearchResultRow"
>
    <iota-icon [icon]="row().icon" size="1.25"></iota-icon>
    <span class="flex-1 min-w-0">
        <span class="block truncate">{{ row().label }}</span>
        <span *ngIf="row().additionalData?.length" class="block truncate text-sm text-base-content/60">
            <ng-container *ngFor="let entry of row().additionalData; let last = last"
                >{{ entry }}<span *ngIf="!last" class="mx-1">·</span></ng-container
            >
        </span>
    </span>
    <span *ngIf="row().activeUntil as activeUntil" class="badge badge-error badge-outline badge-sm shrink-0">
        {{ activeUntil.label }}:&nbsp;{{ activeUntil.date }}
    </span>
    <span *ngIf="row().badge as badge" class="badge badge-sm uppercase">{{ badge }}</span>
</a>
